import { View } from "react-native";
import { Card } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import CartReviewItem from "./CartReviewItem";
import { CartReviewProduct } from "../types";

type Props<T extends CartReviewProduct> = {
  products: T[];
  onProductPress?: (product: T) => void;
  header?: React.ReactNode;
  footer?: React.ReactNode;
};

export default function CartReviewCard<T extends CartReviewProduct>({
  products,
  onProductPress,
  header,
  footer,
}: Props<T>) {
  const tailwind = useTailwind();
  return (
    <Card style={tailwind("rounded-xl")}>
      <Card.Content style={tailwind("gap-4")}>
        {header}

        <View style={tailwind("gap-3")}>
          {products.map((product, index) => {
            return (
              <View key={index}>
                <CartReviewItem
                  product={product}
                  handleCartItemSelect={() => onProductPress?.(product)}
                />
              </View>
            );
          })}
        </View>

        {footer}
      </Card.Content>
    </Card>
  );
}
